(function() {
  'use strict';

  var BEACON_URL = (window.__srnConfig || {}).beaconUrl;
  if (!BEACON_URL) return;

  var u = window.__srnUtils;
  if (!u) return;

  var FLUSH_INTERVAL = 5000;
  var MAX_BATCH = 20;
  var COOKIE_DAYS = 90;
  var queue = [];
  var sessionId = sessionStorage.getItem('srn_sid');
  var isNewSession = false;

  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('srn_sid', sessionId);
    isNewSession = true;
  }

  function getVisitorId() {
    var vid = u.getCookie('srn_vid');
    if (!vid) {
      vid = crypto.randomUUID();
      u.setCookie('srn_vid', vid, COOKIE_DAYS);
    }
    return vid;
  }

  var visitorId = getVisitorId();
  var cachedUtm;
  var cachedEmail;

  function initCaches() {
    var params = new URLSearchParams(window.location.search);
    cachedUtm = {
      utm_source: params.get('utm_source') || undefined,
      utm_medium: params.get('utm_medium') || undefined,
      utm_campaign: params.get('utm_campaign') || undefined
    };
    if (window.__srnCustomer && window.__srnCustomer.email) {
      u.setCookie('srn_email', window.__srnCustomer.email, COOKIE_DAYS);
      cachedEmail = window.__srnCustomer.email;
    } else {
      cachedEmail = u.getCookie('srn_email') || null;
    }
  }

  function pushEvent(name, extra) {
    var ev = {
      event: name,
      visitor_id: visitorId,
      session_id: sessionId,
      page_url: window.location.href.slice(0, 2000),
      referrer: document.referrer ? document.referrer.slice(0, 2000) : undefined,
      email: cachedEmail || undefined
    };
    if (cachedUtm.utm_source) ev.utm_source = cachedUtm.utm_source;
    if (cachedUtm.utm_medium) ev.utm_medium = cachedUtm.utm_medium;
    if (cachedUtm.utm_campaign) ev.utm_campaign = cachedUtm.utm_campaign;
    if (extra) ev.metadata = extra;
    if (extra && extra.product_handle) ev.product_handle = extra.product_handle;
    if (extra && extra.collection_handle) ev.collection_handle = extra.collection_handle;
    queue.push(ev);
  }

  function flush() {
    if (queue.length === 0) return;
    var batch = queue.splice(0, MAX_BATCH);
    var payload = JSON.stringify({ events: batch });

    if (navigator.sendBeacon) {
      navigator.sendBeacon(BEACON_URL, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(BEACON_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true
      }).catch(function() {});
    }
  }

  function init() {
    initCaches();

    if (isNewSession) {
      pushEvent('session_start');
    }

    pushEvent('page_view');

    if (window.__srnProduct) {
      pushEvent('product_view', {
        product_handle: window.__srnProduct.handle,
        product_title: window.__srnProduct.title,
        price: window.__srnProduct.price,
        collections: window.__srnProduct.collections
      });
    }

    if (window.__srnCollection) {
      pushEvent('collection_view', {
        collection_handle: window.__srnCollection.handle
      });
    }

    document.addEventListener('variant:add', function(e) {
      var detail = e.detail || {};
      var items = detail.items || [];
      if (items.length > 0) {
        var item = items[0];
        pushEvent('add_to_cart', {
          product_handle: item.handle,
          product_title: item.product_title,
          variant_title: item.variant_title,
          price: item.price ? item.price / 100 : undefined,
          quantity: item.quantity
        });
      }
    }, true);

    document.addEventListener('dialog:after-show', function(e) {
      var modal = e.target.closest('quick-buy-modal');
      if (!modal) return;
      var handle = modal.getAttribute('handle');
      if (handle) {
        handle = handle.split('?')[0];
        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(p) {
            pushEvent('product_view', {
              product_handle: p.handle,
              product_title: p.title,
              price: p.price ? p.price / 100 : undefined,
              collections: [],
              source: 'quick_view'
            });
          })
          .catch(function() {
            pushEvent('product_view', {
              product_handle: handle,
              source: 'quick_view'
            });
          });
      }
    });

    var variantInteracted = false;
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-option-selector], variant-picker, .variant-picker')) {
        variantInteracted = true;
      }
    }, true);

    document.addEventListener('variant:change', function(e) {
      if (!variantInteracted) return;
      var detail = e.detail || {};
      if (detail.variant && detail.product) {
        pushEvent('variant_selected', {
          product_handle: detail.product.handle,
          variant_id: String(detail.variant.id),
          variant_title: detail.variant.title,
          price: detail.variant.price ? detail.variant.price / 100 : undefined
        });
      }
    }, true);

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('button[name="checkout"], a[href$="/checkout"], form[action$="/checkout"] button[type="submit"], .gokwik-checkout button, #gokwik-buy-now');
      if (btn) {
        pushEvent('checkout_started');
        flush();
      }
    });

    document.addEventListener('input', function(e) {
      var input = e.target;
      if (input.name !== 'q') return;
      var form = input.closest('form[action*="/search"]');
      if (!form) return;
      clearTimeout(input._srnDebounce);
      input._srnDebounce = setTimeout(function() {
        var q = input.value.trim();
        if (q.length >= 3) {
          pushEvent('search_submitted', { query: q.slice(0, 200) });
        }
      }, 2000);
    });

    setInterval(flush, FLUSH_INTERVAL);

    var pageStart = Date.now();
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') {
        var duration = Math.round((Date.now() - pageStart) / 1000);
        if (duration > 2) {
          pushEvent('time_on_page', { duration_seconds: duration });
        }
        flush();
      }
    });
  }

  init();
})();
